import './style.css';

import {
  state,
  loadFavs,
  toggleFav,
  isFav,
  loadSettings,
  setLang,
  setCurrency,
} from './state.js';
import { LANGS, CURRENCIES, t } from './i18n.js';
import { buildSplash, hideSplash, rebuildCityLists } from './modules/splash.js';
import { buildStoriesRail } from './modules/stories.js';
import { HOTELS } from './data.js';
import {
  initMap,
  panToCity,
  panToHotel,
  recenter,
  renderMarkers,
  setOnSelect,
  invalidate,
} from './modules/map.js';
import {
  bindCards,
  buildCards,
  centerCardOn,
  resetScroll,
  setHandlers as setCardHandlers,
  updateHeart,
} from './modules/cards.js';
import {
  closeCitySheet,
  closeSetSheet,
  closeSheet,
  openBooking,
  openCitySheet,
  openDetails,
  openSetSheet,
  setDetailFavHandler,
} from './modules/sheets.js';

function $(id) {
  return document.getElementById(id);
}

function selectHotel(i, centerCard) {
  state.sel = i;
  renderMarkers();
  panToHotel(i);
  if (centerCard) centerCardOn(i);
}

function refresh(reset) {
  $('durs').hidden = state.mode !== 'day';
  document
    .querySelectorAll('#mode button')
    .forEach((b) => b.classList.toggle('on', b.dataset.mode === state.mode));
  buildCards();
  renderMarkers();
  if (reset) {
    state.sel = null;
    resetScroll();
    const first = state.filtered[0];
    if (first != null) selectHotel(first, true);
  }
  syncFavFab();
}

function enterApp(city) {
  state.city = city;
  $('curCity').textContent = city;
  hideSplash();
  initMap(city);
  refresh(true);
}

function changeCity(city) {
  state.city = city;
  state.sel = null;
  $('curCity').textContent = city;
  panToCity(city);
  refresh(true);
}

// ---------- favorites ----------

function syncFavFab() {
  const fab = $('favFab');
  const count = $('favCount');
  if (!fab || !count) return;
  const n = state.favs.size;
  count.textContent = String(n);
  fab.hidden = n === 0;
  fab.classList.toggle('on', state.showFavs);
}

function handleFav(i) {
  if (i === -1) {
    state.showFavs = false;
    refresh(true);
    return;
  }
  toggleFav(i);
  updateHeart(i);
  syncFavFab();
  if (state.showFavs && !isFav(i)) {
    refresh(true);
  }
}

function toggleFavMode() {
  if (state.favs.size === 0) return;
  state.showFavs = !state.showFavs;
  refresh(true);
}

// ---------- i18n / settings ----------

function applyStaticTranslations() {
  document.querySelectorAll('[data-t]').forEach((el) => {
    const key = el.dataset.t;
    if (key) el.textContent = t(key);
  });
  syncSetChip();
}

function syncSetChip() {
  const text = `${state.lang.toUpperCase()} · ${state.currency}`;
  const a = $('spSetChipLabel');
  const b = $('setChipLabel');
  if (a) a.textContent = text;
  if (b) b.textContent = text;
}

function buildSettingsSheet() {
  $('setLang').innerHTML = LANGS.map(
    (l) =>
      `<button class="setpill${state.lang === l.code ? ' on' : ''}" data-lang="${l.code}">${l.label}</button>`,
  ).join('');
  $('setCur').innerHTML = CURRENCIES.map(
    (c) =>
      `<button class="setpill${state.currency === c.code ? ' on' : ''}" data-cur="${c.code}">${c.label}</button>`,
  ).join('');
}

function bindSettings() {
  $('spSetChip').addEventListener('click', () => {
    buildSettingsSheet();
    openSetSheet();
  });
  $('setChip').addEventListener('click', () => {
    buildSettingsSheet();
    openSetSheet();
  });
  $('setSheetX').addEventListener('click', closeSetSheet);
  $('setDone').addEventListener('click', closeSetSheet);

  $('setLang').addEventListener('click', (e) => {
    const b = e.target.closest('[data-lang]');
    if (!b) return;
    if (setLang(b.dataset.lang)) {
      onLocaleChange();
      buildSettingsSheet();
    }
  });
  $('setCur').addEventListener('click', (e) => {
    const b = e.target.closest('[data-cur]');
    if (!b) return;
    if (setCurrency(b.dataset.cur)) {
      onLocaleChange();
      buildSettingsSheet();
    }
  });
}

function onLocaleChange() {
  applyStaticTranslations();
  rebuildCityLists();
  // Rebuild any in-app data that depends on lang/currency.
  buildCards();
  renderMarkers();
}

// ---------- topbar / map controls ----------

function bindControls() {
  $('mode').addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    state.mode = b.dataset.mode;
    refresh(true);
  });

  $('durs').addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    state.hours = +b.dataset.h;
    document
      .querySelectorAll('#durs .dur')
      .forEach((x) => x.classList.toggle('on', x === b));
    refresh(true);
  });

  $('citysel').addEventListener('click', openCitySheet);
  $('citySheetX').addEventListener('click', closeCitySheet);
  $('recenter').addEventListener('click', recenter);
  $('favFab').addEventListener('click', toggleFavMode);
  $('scrim').addEventListener('click', () => {
    closeSheet();
    closeCitySheet();
    closeSetSheet();
  });

  window.addEventListener('resize', invalidate);
}

// ---------- bootstrap ----------
loadFavs();
loadSettings();
applyStaticTranslations();
setOnSelect(selectHotel);
setCardHandlers({
  onSelect: selectHotel,
  onBook: openBooking,
  onDetails: (i) => {
    selectHotel(i, true);
    openDetails(i);
  },
  onFav: handleFav,
});
setDetailFavHandler(handleFav);
bindCards();
bindControls();
bindSettings();
buildSplash({
  onEnter: enterApp,
  onChange: (city) => {
    closeCitySheet();
    changeCity(city);
  },
});
syncFavFab();
buildStoriesRail({
  onBook: (hotelIdx) => {
    const h = HOTELS[hotelIdx];
    enterApp(h.city);
    selectHotel(hotelIdx, true);
    openDetails(hotelIdx);
  },
});
